// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"c013f797","707":"062bfa86","937":"97f15bf0"}[chunkId] + ".chunk.js";
};